import React from 'react';
import PropTypes from 'prop-types';
import { Body, Title } from '../style';
import { Arrow, CardWrapper, CardsWrapper, Image } from './style';
import arrowLeft from '../../../assets/img/arrow-right.svg';
import arrowBottom from '../../../assets/img/arrow-bottom-mobile.svg';
import { HtmlRaw } from '../../../atoms';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';

const HowToComponent = ({ mediaIsPhone, mediaIsTablet, data, title, body }) => {
  return (
    <>
      <Title>{title}</Title>
      <Body>
        <HtmlRaw html={body} />
      </Body>
      {data && (
        <CardsWrapper>
          {(data || []).map(({ data: item }, index) => (
            <div key={`card-${index}`} style={{ position: 'relative' }}>
              <CardWrapper>
                <div className="step">{item?.phase_number}</div>
                <Image src={item?.icon} alt="" />
                <h3>{item.title}</h3>
                <p>{item?.description}</p>
              </CardWrapper>
              {index + 1 < data?.length && (
                <Arrow
                  src={mediaIsPhone || mediaIsTablet ? arrowBottom : arrowLeft}
                  alt=""
                />
              )}
            </div>
          ))}
        </CardsWrapper>
      )}
    </>
  );
};

HowToComponent.propTypes = {
  mediaIsPhone: PropTypes.bool,
  mediaIsTablet: PropTypes.bool,
  data: PropTypes.array,
  title: PropTypes.string,
  body: PropTypes.string,
};

export default withMediaQueries(HowToComponent);
